import { useParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, CheckCircle, Star } from "lucide-react";
import { Button } from "@/components/ui/button";

// Industry data
const industriesData = {
    "rakentaminen": {
        title: "Rakentaminen",
        heroTitle: "Tilitoimistopalvelut rakennusyrittäjälle",
        heroDescription: "Purkamisesta maanrakennukseen. Perustuksista pystytykseen. LVI-töistä maalaukseen ja aina pihatöihin saakka. Me haluamme auttaa kaikkia rakentajia, oli kyse sitten uudisrakentamisesta tai saneerauksesta, projektikoosta riippumatta.",
        image: "https://images.pexels.com/photos/29288255/pexels-photo-29288255.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        color: "#D4A853",
        benefits: [
            "Rakennusalan erityisosaaminen",
            "Käännetyn ALV:n hallinta",
            "Urakkalaskutuksen tuki",
            "Projektikohtainen seuranta"
        ],
        reviews: [
            { text: "Minulle ainakin on ollut kaikilta ystävällistä ja iloista palvelua.", rating: 5 },
            { text: "Ei ole mitään valittamista. Kaikki toimii ja asiantuntemus on.", rating: 5 },
            { text: "Mukava henkilökunta ja aina asiat nopeasti selvitetty. KIITOS", rating: 5 }
        ]
    },
    "auto": {
        title: "Auto- ja konekauppa",
        heroTitle: "Tilitoimistopalvelut autoalalle",
        heroDescription: "Autokaupan ja korjaamoiden taloushallinto vaatii erityisosaamista. Marginaaliverotus, vaihtoautot ja varaosamyynti - me tunnemme autoalan erityispiirteet.",
        image: "https://images.unsplash.com/photo-1619642737579-a7474bee1044?crop=entropy&cs=srgb&fm=jpg&q=85",
        color: "#3B82F6",
        benefits: [
            "Marginaaliverotuksen hallinta",
            "Vaihtoautokaupan kirjanpito",
            "Korjaamopalveluiden laskutus",
            "Varaosavaraston seuranta"
        ],
        reviews: [
            { text: "Erinomaista palvelua autoalan yrittäjälle!", rating: 5 },
            { text: "Ymmärtävät marginaaliverotuksen hyvin.", rating: 5 }
        ]
    },
    "kauppa": {
        title: "Kauppa",
        heroTitle: "Tilitoimistopalvelut kaupan alalle",
        heroDescription: "Vähittäiskaupasta tukkukauppaan - tarjoamme räätälöidyt taloushallinnon palvelut kaupan alan yrityksille. Kassajärjestelmät, varastonhallinta ja myyntiraportit haltuun.",
        image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&q=80",
        color: "#10B981",
        benefits: [
            "Kassajärjestelmien integraatiot",
            "Varastonhallinnan tuki",
            "Myyntiraportointi",
            "Verkkokaupan kirjanpito"
        ],
        reviews: [
            { text: "Loistava kumppani kaupan kirjanpitoon!", rating: 5 }
        ]
    },
    "kuljetus": {
        title: "Kuljetus",
        heroTitle: "Tilitoimistopalvelut kuljetusalalle",
        heroDescription: "Kuljetusalan kirjanpito vaatii erityisosaamista. Ajopäiväkirjat, kilometrikorvaukset, polttoainekustannukset - hoidamme kaiken puolestasi.",
        image: "https://images.pexels.com/photos/33897865/pexels-photo-33897865.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        color: "#F59E0B",
        benefits: [
            "Ajopäiväkirjojen käsittely",
            "Kilometrikorvausten laskenta",
            "Polttoainekustannusten seuranta",
            "Cabotage-säännösten tuntemus"
        ],
        reviews: [
            { text: "Ymmärtävät kuljetusalan haasteet!", rating: 5 }
        ]
    },
    "konsultointi": {
        title: "Suunnittelu- ja konsultointitoiminta",
        heroTitle: "Tilitoimistopalvelut asiantuntijayrityksille",
        heroDescription: "Konsultti- ja asiantuntijayritysten taloushallinto on meidän vahvuutemme. Projektilaskutus, tuntikirjaukset ja matkakustannukset hallintaan.",
        image: "https://images.pexels.com/photos/36733331/pexels-photo-36733331.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        color: "#8B5CF6",
        benefits: [
            "Projektilaskutuksen hallinta",
            "Tuntikirjausten seuranta",
            "Matkakustannusten käsittely",
            "Konsulttien verotus"
        ],
        reviews: [
            { text: "Erinomaista palvelua konsulttiyritykselle!", rating: 5 }
        ]
    },
    "ravintola": {
        title: "Ravintola",
        heroTitle: "Tilitoimistopalvelut ravintola-alalle",
        heroDescription: "Ravintola-alan kirjanpito vaatii erityisosaamista. Kassajärjestelmät, henkilöstökulut, raaka-ainekustannukset - me tunnemme ravintola-alan.",
        image: "https://images.unsplash.com/photo-1669944734760-cf3279e219f0?crop=entropy&cs=srgb&fm=jpg&q=85",
        color: "#EF4444",
        benefits: [
            "Kassajärjestelmien integraatiot",
            "Henkilöstökulujen hallinta",
            "Raaka-ainekustannusten seuranta",
            "Ravintola-alan verotus"
        ],
        reviews: [
            { text: "Ymmärtävät ravintola-alan erityispiirteet!", rating: 5 }
        ]
    },
    "hoiva": {
        title: "Hoiva",
        heroTitle: "Tilitoimistopalvelut hoiva-alalle",
        heroDescription: "Hoiva-alan taloushallinto vaatii tarkkuutta ja ymmärrystä alan erityispiirteistä. Palvelusetelit, Kela-korvaukset ja henkilöstökulut hallintaan.",
        image: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=800&q=80",
        color: "#EC4899",
        benefits: [
            "Palvelusetelien käsittely",
            "Kela-korvausten hallinta",
            "Henkilöstökulujen seuranta",
            "Hoiva-alan verotus"
        ],
        reviews: [
            { text: "Loistava kumppani hoiva-alan yrittäjälle!", rating: 5 }
        ]
    },
    "palvelut": {
        title: "Palveluyritykset",
        heroTitle: "Tilitoimistopalvelut palveluyrityksille",
        heroDescription: "Palveluyritysten kirjanpito on meidän ydinosaamisemme. Laskutus, henkilöstökulut ja projektinhallinta sujuvasti.",
        image: "https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=800&q=80",
        color: "#06B6D4",
        benefits: [
            "Palvelulaskutuksen hallinta",
            "Henkilöstökulujen seuranta",
            "Projektien kirjanpito",
            "Palvelualan verotus"
        ],
        reviews: [
            { text: "Suosittelen lämpimästi!", rating: 5 }
        ]
    }
};

const ToimialaSivu = () => {
    const { toimiala } = useParams();
    const data = industriesData[toimiala];

    if (!data) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="text-center">
                    <h1 className="text-2xl font-semibold mb-4">Toimialaa ei löytynyt</h1>
                    <Link to="/ratkaisut/toimialaratkaisut" className="text-green-600 hover:underline">
                        Takaisin toimialoihin
                    </Link>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-white">
            {/* Hero Section with decorative background */}
            <section 
                className="relative overflow-hidden"
                style={{ backgroundColor: data.color }}
            >
                {/* Decorative curves */}
                <div className="absolute inset-0 overflow-hidden">
                    <svg 
                        className="absolute top-0 right-0 h-full w-1/2 opacity-30"
                        viewBox="0 0 400 600" 
                        fill="none"
                    >
                        <path 
                            d="M200 0C200 150 350 200 350 350C350 500 200 550 200 600" 
                            stroke="currentColor" 
                            strokeWidth="80"
                            className="text-white/40"
                            fill="none"
                        />
                        <path 
                            d="M100 100C100 250 250 300 250 450C250 600 100 650 100 700" 
                            stroke="currentColor" 
                            strokeWidth="60"
                            className="text-white/30"
                            fill="none"
                        />
                    </svg>
                </div>

                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28 relative z-10">
                    <div className="grid lg:grid-cols-2 gap-12 items-center">
                        {/* Content */}
                        <motion.div
                            initial={{ opacity: 0, x: -30 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.6 }}
                        >
                            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-white tracking-tight mb-6">
                                {data.heroTitle}
                            </h1>
                            <p className="text-lg text-white/90 leading-relaxed mb-8">
                                {data.heroDescription}
                            </p>
                            <Link to="/#yhteystiedot">
                                <Button 
                                    variant="outline"
                                    className="border-2 border-white text-white hover:bg-white hover:text-slate-900 px-8 py-3 rounded-full"
                                >
                                    Voimmeko auttaa?
                                </Button>
                            </Link>
                        </motion.div>

                        {/* Image */}
                        <motion.div
                            initial={{ opacity: 0, x: 30 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.6, delay: 0.2 }}
                            className="relative"
                        >
                            <div className="relative">
                                {/* Image frame */}
                                <div 
                                    className="absolute -inset-4 rounded-2xl"
                                    style={{ 
                                        border: `4px solid ${data.color}`,
                                        filter: 'brightness(0.8)'
                                    }}
                                />
                                <img 
                                    src={data.image}
                                    alt={data.title}
                                    className="relative rounded-2xl shadow-2xl w-full h-[350px] object-cover"
                                />
                            </div>
                        </motion.div>
                    </div>
                </div>
            </section>

            {/* Benefits Section */}
            <section className="py-20 bg-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        className="text-center mb-12"
                    >
                        <h2 className="text-2xl sm:text-3xl font-semibold text-slate-900 mb-4">
                            Mitä saat meiltä?
                        </h2>
                    </motion.div>

                    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
                        {data.benefits.map((benefit, index) => (
                            <motion.div
                                key={index}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: index * 0.1 }}
                                className="bg-slate-50 rounded-xl p-6 text-center"
                            >
                                <div 
                                    className="w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4"
                                    style={{ backgroundColor: `${data.color}20` }}
                                >
                                    <CheckCircle className="h-6 w-6" style={{ color: data.color }} />
                                </div>
                                <p className="font-medium text-slate-800">{benefit}</p>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Reviews Section */}
            <section className="py-20 bg-[#F8FAFC]">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        className="text-center mb-12"
                    >
                        <h2 className="text-2xl sm:text-3xl font-semibold text-slate-900 mb-4">
                            Mitä asiakkaamme sanovat?
                        </h2>
                        <div className="flex items-center justify-center gap-1 mb-2">
                            {[1, 2, 3, 4, 5].map((star) => (
                                <Star key={star} className="h-6 w-6 fill-yellow-400 text-yellow-400" />
                            ))}
                        </div>
                        <p className="text-slate-600">{data.reviews.length} arvostelua</p>
                    </motion.div>

                    <div className="grid md:grid-cols-3 gap-6">
                        {data.reviews.map((review, index) => (
                            <motion.div
                                key={index}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: index * 0.1 }}
                                className="bg-white rounded-xl p-6 shadow-sm"
                            >
                                <div className="flex gap-1 mb-3">
                                    {[1, 2, 3, 4, 5].map((star) => (
                                        <Star 
                                            key={star} 
                                            className={`h-4 w-4 ${star <= review.rating ? 'fill-yellow-400 text-yellow-400' : 'text-gray-300'}`} 
                                        />
                                    ))}
                                </div>
                                <p className="text-slate-600 italic">"{review.text}"</p>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="py-20 bg-[#1a1a1a]">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                    >
                        <h2 className="text-2xl sm:text-3xl font-semibold text-white mb-6">
                            Haluatko kuulla lisää?
                        </h2>
                        <p className="text-white/80 mb-8">
                            Ota yhteyttä ja kerro tarpeistasi - autamme sinua löytämään parhaan ratkaisun.
                        </p>
                        <Link to="/#yhteystiedot">
                            <Button className="bg-white text-[#1a1a1a] hover:bg-slate-100 px-8 py-3 rounded-full">
                                Ota yhteyttä
                                <ArrowRight className="ml-2 h-4 w-4" />
                            </Button>
                        </Link>
                    </motion.div>
                </div>
            </section>
        </div>
    );
};

export default ToimialaSivu;
